import { render } from "./PersonsView.vue?vue&type=template&id=005973ee&ts=true"
import script from "./PersonsView.vue?vue&type=script&lang=ts"
export * from "./PersonsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QIcon,QBtn});
